// export const WEB_API = 'http://159.65.3.230:3230/api/v1/';
export const WEB_SITE = 'https://staging.law.go.th';

export const WEB_API = 'https://0smnyp1dpi.execute-api.ap-southeast-7.amazonaws.com/uat/';
export const WEB_API_LAMBDA = 'https://0smnyp1dpi.execute-api.ap-southeast-7.amazonaws.com/uat/submit_survey/api/survey_uat';
//export const WEB_API_DASHBOARD = 'http://localhost:3230/dga-user-service-survey';
export const WEB_API_DASHBOARD = 'https://0smnyp1dpi.execute-api.ap-southeast-7.amazonaws.com/uat';

export const WEB_OPEN_ID = 'https://connect.dga.or.th/connect/authorize?response_type=code&client_id=afc3f077-10ea-47a3-98c0-d23b258ee0bf&redirect_uri=https://staging.law.go.th/loginsuccess&scope=openid personal_token citizen_id given_name family_name email phone_number email_require email_verified mobile_require ial_level_require preferred_username'
export const WEB_OPEN_ID_LOGOUT = 'https://connect.dga.or.th/connect/endsession?id_token_hint=&post_logout_redirect_uri=https://staging.law.go.th/logout'
export const WEB_OPEN_ID_PROFILE = 'https://connect.dga.or.th/Account/Profile'
export const WEB_OPEN_ID_PASSWORD = 'https://connect.dga.or.th/Account/ChangePassword'
//export const WEB_API = 'http://192.168.72.154:8000/';
//export const WEB_API = 'https://lawtest.egov.go.th/api/v1/';
//export const WEB_API = `http://localhost:3230/`;

//beta
//export const WEB_API = 'http://164.115.77.167:3230/api/v1/';
//export const WEB_SITE = 'https://lawtest.egov.go.th/';

// //beta domain
// export const WEB_API = 'https://lawtest.egov.go.th/api/v1/';

//export const WEB_API = 'https://lawtestbeta.egov.go.th/api/v1/';
